import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
// Layout
import Layout from "./components/Layout";
// Pages
import HomePage from "./pages/Homepage";
import AboutPage from "./pages/Aboutpage";
import ProductsPage from "./pages/ProductsPage";
import SolutionsPage from "./pages/Solutionspage";
import ServicesPage from "./pages/ServicesPage";
import ContactPage from "./pages/ContactPage";
import AmyloidConnectPage from "./pages/products/AmyloidConnectpage";
import NephroTraxPage from "./pages/products/NephroTraxPage";
import CompassProductPage from "./pages/compass/CompassProductPage";
import ResourceClanPage from "./pages/products/ResourceClanPage";
import PlatformsPage from "./pages/Platformspage";
import Pharmapage from "./pages/Pharmapage"
import CompassPage from "./pages/products/CompassPage";


// Theme
const theme = createTheme({
  palette: {
    primary: { main: "#1a237e" },
    secondary: { main: "#00897b" },
    warning: { main: "#f9a825" },
    background: { default: "#f8fafc" },
  },
  typography: {
    fontFamily: "'Inter', 'Roboto', sans-serif",
    h1: { fontWeight: 800 },
    h2: { fontWeight: 700 },
    h3: { fontWeight: 700 },
    h4: { fontWeight: 600 },
    h5: { fontWeight: 600 },
    h6: { fontWeight: 600 },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          textTransform: "none",
          fontWeight: 600,
          fontSize: "1rem",
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: { borderRadius: 16 },
      },
    },
    MuiToolbar: {
      styleOverrides: {
        root: { minHeight: "70px !important" },
      },
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Routes>
          {/* Compass renders standalone — it has its own header/branding,
              so it deliberately skips the marketing site's Layout wrapper
              (no VeraInsight nav/footer stacked on top of it). */}
          <Route path="/compass" element={<CompassProductPage />} />

          <Route
            path="*"
            element={
              <Layout>
                <Routes>
                  <Route path="/"                          element={<HomePage />} />
                  <Route path="/about"                     element={<AboutPage />} />
                  <Route path="/products"                  element={<ProductsPage />} />
                  <Route path="/products/amyloidconnect"   element={<AmyloidConnectPage />} />
                  <Route path="/products/nephrotrax"       element={<NephroTraxPage />} />
                  <Route path="/products/compass"          element={<CompassPage />} />
                  <Route path="/products/resourceclan"     element={<ResourceClanPage />} />
                  <Route path="/solutions"                 element={<SolutionsPage />} />
                  <Route path="/services"                  element={<ServicesPage />} />
                  <Route path="/contact"                   element={<ContactPage />} />
                  <Route path="/platforms"                 element={<PlatformsPage />} />
                  <Route path="/pharma"                    element={<Pharmapage />} />
                </Routes>
              </Layout>
            }
          />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;